export const CAPTURE_INTENT = 'capture';

export const AUTHORIZE_INTENT = 'authorize';

export const SDK_FLOW_SLUG = {
  ADVANCED: 'advanced',
  STANDARD: 'standard',
  FASTLANE: 'fastlane'
};

export const CARD_FIELDS_SNIPPET_KEYS = {
  PARENT: 'parent_card_field_styles',
  NAME: 'card_name_field_styles',
  NUMBER: 'card_number_field_styles',
  EXPIRY_DATE: 'card_expiry_date_field_styles',
  CVV: 'card_cvv_field_styles'
};
